// AUTO-CURATED ICON REGISTRY — do not hand-edit casually.
//
// WHY THIS EXISTS: AppIcon.jsx previously did `import * as LucideIcons from
// 'lucide-react'`, which defeats tree-shaking and bundled the ENTIRE
// lucide icon set (~1.3 MB of source) into the homepage entry chunk. This
// module instead does NAMED imports of only the icons the app actually
// references (by string name in JSX `name="..."` props and in component
// data `icon: "..."` fields), so Rollup ships just those.
//
// Names were collected by scanning src for icon-context string literals and
// intersecting with lucide-react's real exports. AppIcon falls back to
// <HelpCircle/> for any name not found here (same graceful behavior as
// before), so a missed icon degrades rather than crashes.
//
// TO REGENERATE after adding new icons: re-run the collector in the perf MR
// (scan `name={?"X"` and `icon: "X"` patterns, intersect with lucide), or
// just add the missing PascalCase name to the import list below.

import {
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  Award,
  Banknote,
  BarChart3,
  Bell,
  BookOpen,
  Box,
  Building,
  Building2,
  Calculator,
  Calendar,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cloud,
  Cookie,
  CreditCard,
  DollarSign,
  Download,
  Edit,
  Eye,
  EyeOff,
  FileCheck,
  FileText,
  Filter,
  Folder,
  GitBranch,
  GraduationCap,
  Grid3x3,
  HardHat,
  Headphones,
  Heart,
  Home,
  Info,
  Landmark,
  Layers,
  Lightbulb,
  List,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  MousePointerClick,
  Package,
  Palette,
  Percent,
  Phone,
  Play,
  Quote,
  RefreshCw,
  Rocket,
  RotateCcw,
  Ruler,
  Scale,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Star,
  Tag,
  Target,
  ThumbsUp,
  Trash2,
  TrendingDown,
  TrendingUp,
  Umbrella,
  User,
  UserCheck,
  UserPlus,
  UserX,
  Users,
  Video,
  Wallet,
  Wrench,
  XCircle,
  Zap,
  HelpCircle,
} from 'lucide-react';

export const ICON_REGISTRY = {
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  Award,
  Banknote,
  BarChart3,
  Bell,
  BookOpen,
  Box,
  Building,
  Building2,
  Calculator,
  Calendar,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ClipboardCheck,
  ClipboardList,
  Clock,
  Cloud,
  Cookie,
  CreditCard,
  DollarSign,
  Download,
  Edit,
  Eye,
  EyeOff,
  FileCheck,
  FileText,
  Filter,
  Folder,
  GitBranch,
  GraduationCap,
  Grid3x3,
  HardHat,
  Headphones,
  Heart,
  Home,
  Info,
  Landmark,
  Layers,
  Lightbulb,
  List,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  MousePointerClick,
  Package,
  Palette,
  Percent,
  Phone,
  Play,
  Quote,
  RefreshCw,
  Rocket,
  RotateCcw,
  Ruler,
  Scale,
  Search,
  Server,
  Settings,
  Share2,
  Shield,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Star,
  Tag,
  Target,
  ThumbsUp,
  Trash2,
  TrendingDown,
  TrendingUp,
  Umbrella,
  User,
  UserCheck,
  UserPlus,
  UserX,
  Users,
  Video,
  Wallet,
  Wrench,
  XCircle,
  Zap,
};

export { HelpCircle };

export default ICON_REGISTRY;
